// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1tMoC","title":"Info_title__1s8qm","links":"Info_links__29biy","link":"Info_link__13FkZ","logo":"Info_logo__2vUOC"};